export default __webpack_public_path__ + "static/media/cable.0448d418.svg";